<template>
    <div>
        <el-card shadow="hover">
            <el-select
                v-model="expList.value"
                placeholder="请选择"
                filterable
                @change="handleSelectChange"
            >
                <el-option
                    v-for="item in expList.options"
                    :key="item.exp_id"
                    :label="item.title"
                    :value="item.exp_id"
                >
                </el-option>
            </el-select>
        </el-card>
        <br />
        <el-card shadow="hover">
            <el-table v-loading="list.loading" :data="list.data">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column label="用户名" prop="name"></el-table-column>
                <el-table-column label="成绩" prop="score"></el-table-column>
                <el-table-column
                    label="提交时间"
                    prop="subtime"
                ></el-table-column>
                <el-table-column
                    label="耗时-秒"
                    prop="duration"
                ></el-table-column>
                <el-table-column label="数据" prop="data"></el-table-column>
            </el-table>
            <br />
            <el-pagination
                :current-page="list.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="list.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="list.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
import {
    showVirtualSimulation,
    apiGetDataList
} from "@/api/views/manager/expData";

export default {
    name: "ExpData",
    data() {
        return {
            // 列表
            list: {
                // 列表加载状态
                loading: true,
                page: 1,
                size: 10,
                search: "",
                total: 0,
                data: []
            },
            // 实验列表
            expList: {
                options: [],
                value: null
            }
        };
    },
    created() {
        this.getExpList();
    },
    methods: {
        getExpList() {
            let search = {};
            search.page = 1;
            search.showNum = 0;
            if (this.$store.state.userInfo) {
                search.fuzeren = this.$store.state.userInfo.name;
            }
            showVirtualSimulation(search).then(res => {
                this.expList.options = res.virtualList;
                if(res.virtualList.length==0){
                     this.$message({
                        message: "暂无数据",
                        type: "warning"
                    });

                }else{
                    this.expList.value = res.virtualList[0].exp_id;
                    this.getDataList();

                }
      
            });
        },
        handleSizeChange(size) {
            this.list.size = size;
            this.getDataList();
        },
        handleCurrentChange(current) {
            this.list.page = current;
            this.getDataList();
        },
        getDataList() {
            this.list.loading = true;
            apiGetDataList({
                page: this.list.page,
                pagesize: this.list.size,
                exp_id: this.expList.value
            }).then(res => {
                this.list.total = parseInt(res.expDataCount);
                this.list.data = res.expDataList;
                this.list.loading = false;
            });
        },
        handleSelectChange(val) {
            this.expList.value = val;
            this.getDataList();
        }
    }
};
</script>
